var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"heading"},[_c('h3',{staticClass:"mb-s"},[_vm._v(_vm._s(_vm.$t('title.changePassword')))]),_c('div',{staticClass:"line-height-s"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])]),_c('ChangePasswordForm',{attrs:{"isLoading":_vm.isLoading},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }